/**
 * IconSelector 定数定義
 */

/** モーダルサイズ */
export const MODAL_SIZE = {
  WIDTH: 1100,
  HEIGHT: 800,
} as const;

/** プレビューサイズ */
export const PREVIEW_SIZE = {
  LARGE: 160,
  SMALL: 80,
} as const;

/** グリッド設定 */
export const GRID_CONFIG = {
  SYSTEM_ICONS_COLUMNS: 8,
  SYSTEM_ICONS_ROWS: 2,
} as const;

/** プリセットアイコンサイズ */
export const PRESET_ICON_SIZE = 84;
